export default __webpack_public_path__ + "static/media/headerb.8aaa9852.jpg";